import type { Store as SanityStore } from 'libs/sanity/types/generated';

export interface Store {
    name: string;
    type?: Record<string, boolean>;
    hours?: {
        workingDays?: string;
    };
    media?: {
        images?: string[];
    };
    address: {
        city: string;
        country: string;
        zipCode: string;
        continent?: string;
        coordinates?: {
            lat: number;
            lng: number;
            _type?: string;
        };
        streetAddress: string;
    };
    contactInformation?: {
        websiteUrl?: string;
        phoneNumber?: string;
        emailAddress?: string;
    };
    content?: SanityStore['content'];
}

export const DEFAULT_MAP_CENTER = { lat: 59.0, lng: 14.0 };
export const DEFAULT_MAP_ZOOM = 5;
